import Client, { Local, Environment, PreviewEnv, type ClientOptions } from "./encore.gen";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Changes may need to be applied to Vercel.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

type Targets = "development" | "preview" | "production" | "staging" | "local";

// biome-ignore lint/suspicious/noExplicitAny: typeguard
const isTargets = (value: any): value is Targets => {
  return (
    value === "development" || value === "preview" || value === "production" || value === "local" || value === "staging"
  );
};

const getTarget = (target: string, pr?: string) => {
  // Local Development
  const isTarget = isTargets(target);
  if (!isTarget) {
    console.log("refusing to use target:", target);
    return Environment("production");
  }
  // Ephemeral Preview Environments
  if (target === "preview") {
    if (pr) {
      return PreviewEnv(pr);
    }
    // Use the development environment for envs that don't have a PR,
    // since Encore only create envs with PRs.
    return Environment("development");
  }
  // Durable Environments
  switch (target) {
    case "development":
      return Environment("development");
    case "staging":
      return Environment("staging");
    case "local":
      return Local;
    default:
      return Environment("production");
  }
};

let clientTarget = Environment("production"); // Default to production

export const init = (target?: string, pr?: string) => {
  clientTarget = getTarget(target ?? "production", pr);
};

export const getClientTarget = () => clientTarget;

/**
 * Rewrites calls to localhost:4000 to the reverse proxy url on the front-end so that
 * we can make https calls to the control plane. This is only for local development.
 */
const fetcher: ClientOptions["fetcher"] = async (input, init) => {
  const localURL = `https://${APP_DOMAIN}/__controlplane__`;
  let url: URL;

  if (typeof input === "string" || input instanceof URL) {
    url = new URL(input.toString());
  } else {
    url = new URL(input.url);
  }

  // Rewrite localhost:4000 to proxy
  if (url.hostname === "localhost" && url.port === "4000") {
    url.hostname = new URL(localURL).hostname;
    url.protocol = new URL(localURL).protocol;
    url.port = new URL(localURL).port; // usually empty for https

    url.pathname = `/__controlplane__${url.pathname}`;
  }

  // Pass the modified URL to fetch
  return fetch(url.toString(), init);
};

/**
 * Get the request client. This function is used to create a new client instance with the correct target.
 * The target is configured based on the environment variables. For more information, see `/docs/system/vercel.md`.
 * @param token
 */
export const getRequestClient = (token: () => string | undefined) => {
  return new Client(clientTarget, {
    auth: token,
    fetcher: RUNNING_ENV === "local" ? fetcher : undefined,
  });
};
